import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Button, Column, Row, TextButton, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { ClientInvoicesListView } from '~/components/ClientInvoicesListView/ClientInvoicesListView';
import { useLocaleKeys } from '~/i18n';
import { useClientInvoices } from '../../hooks/useClientInvoices';
export const GetIssuedInvoicesTabTID = (parentTestId)=>getTestIds(parentTestId);
export function IssuedInvoicesTab(param) {
    let { clientId, onBillClient, isArchived } = param;
    const { IssuedInvoicesTabTestIds: TID } = useMemo(()=>GetIssuedInvoicesTabTID(), []);
    const { t: texts } = useLocaleKeys('pages.clientDetail.tabContent.issuedInvoices');
    const { invoices, isLoading, isError, refetch } = useClientInvoices(clientId);
    if (!isLoading && isError && invoices.length === 0) {
        return /*#__PURE__*/ _jsx(Box, {
            testId: TID.Root(),
            children: /*#__PURE__*/ _jsxs(Column, {
                gap: 12,
                alignItems: "start",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: TID.ErrorMessage(),
                        skin: "secondary",
                        children: texts.error.message()
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        bi: {
                            name: 'client_detail_issued_invoices_retry'
                        },
                        testId: TID.ErrorRetry(),
                        skin: "primaryOutline",
                        onClick: refetch,
                        children: texts.error.retry()
                    })
                ]
            })
        });
    }
    if (!isLoading && invoices.length === 0) {
        return /*#__PURE__*/ _jsx(Box, {
            testId: TID.Root(),
            width: "100%",
            padding: "24px 0 0 0",
            children: /*#__PURE__*/ _jsxs(Row, {
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
                gap: 4,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: TID.Empty(),
                        skin: "standard",
                        children: texts.emptyMessage()
                    }),
                    !isArchived && /*#__PURE__*/ _jsx(TextButton, {
                        bi: {
                            name: 'client_detail_issued_invoices_bill_client'
                        },
                        testId: TID.EmptyCta(),
                        skin: "primary",
                        weight: "normal",
                        underline: "none",
                        onClick: onBillClient,
                        children: texts.emptyCta()
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ _jsx(Box, {
        testId: TID.Root(),
        width: "100%",
        children: /*#__PURE__*/ _jsx(Box, {
            testId: TID.ListView(),
            width: "100%",
            children: /*#__PURE__*/ _jsx(ClientInvoicesListView, {
                invoices: invoices,
                isLoading: isLoading,
                customerId: clientId,
                testId: TID.ListView(),
                hideManagePaymentMethods: isArchived
            })
        })
    });
}
